import "../components/Footer.css";
import React, { useContext } from "react";
import { AiOutlineMail } from "react-icons/ai";
import { HiOutlineLocationMarker } from "react-icons/hi";
import PortfolioContext from '../context/PortfolioContext';

function Footer() {
  const { darkTheme } = useContext(PortfolioContext);
  return (
    <footer className={darkTheme? "footer-dark" : "footer-light"}>
      <h5 className="email"><AiOutlineMail size={30}/>vitor.o.silva95@gmail.com</h5>
      <h5 className="email"><HiOutlineLocationMarker size={30}/>Betim , Minas Gerais</h5>
      <h5>©2021</h5>
    </footer>
  )
}

export default Footer;